exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pseudo-console_pseudo-console-wrapper_3pcNA {\n    font-family: monospace;\n    display: flex;\n    flex-direction: column;\n    background-color: black;\n    color: white;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n", ""]);

// exports
exports.locals = {
	"pseudo-console-wrapper": "pseudo-console_pseudo-console-wrapper_3pcNA",
	"pseudoConsoleWrapper": "pseudo-console_pseudo-console-wrapper_3pcNA"
};